import React from 'react';
import PropTypes from 'prop-types';
import { DatePicker } from 'antd';
import { CalendarOutlined } from '@ant-design/icons';
import styled from '@emotion/styled';
import locale from 'antd/es/date-picker/locale/de_DE';
import { dateFormat } from '../../../utils';
import moment from 'moment';

const PickerWrap = styled.div`
  position: relative;
  display: inline-flex;

  .hidden-ant-picker {
    position: absolute;
    inset: 0;
    width: 178px;
    height: 40px;
    opacity: 0;
    pointer-events: none;
  }
`;

const DateButton = styled.button`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 4px;
  width: 178px;
  height: 40px;
  padding: 10px 14px;
  background: #ffffff;
  border: 1px solid #d5d7da;
  box-shadow: 0px 1px 2px rgba(10, 13, 18, 0.05),
    inset 0px 0px 0px 1px rgba(10, 13, 18, 0.18),
    inset 0px -2px 0px rgba(10, 13, 18, 0.05);
  border-radius: 8px;
  cursor: pointer;
`;

const IconWrap = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  color: #414651;
`;

const DateText = styled.span`
  font-family: Inter, sans-serif;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  color: #717680;
`;

const DatePickerGlobalStyle = styled.div``;

const popupStyles = `
.custom-date-picker-dropdown {
  width: 328px !important;
  z-index: 9999 !important;
}

.custom-date-picker-panel-wrap {
  position: relative;
}

.custom-date-picker-dropdown .ant-picker-panel-container {
  width: 328px !important;
  background: #ffffff;
  border: 1px solid #e9eaeb;
  box-shadow:
    0px 20px 24px -4px rgba(10, 13, 18, 0.08),
    0px 8px 8px -4px rgba(10, 13, 18, 0.03),
    0px 3px 3px -1.5px rgba(10, 13, 18, 0.04);
  border-radius: 12px;
  overflow: hidden;
}

.custom-date-picker-dropdown .ant-picker-panel {
  border: 0;
}

.custom-date-picker-dropdown .ant-picker-date-panel {
  width: 328px;
}

.custom-date-picker-dropdown .ant-picker-header {
  padding: 20px 24px 4px;
  border-bottom: 0;
}

.custom-date-picker-dropdown .ant-picker-header-view {
  font-family: Inter, sans-serif;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: #414651;
}

.custom-date-picker-dropdown .ant-picker-header button {
  width: 32px;
  height: 32px;
  border-radius: 6px;
  color: #a4a7ae;
}

.custom-date-picker-top-actions {
  position: absolute;
  top: 64px;
  left: 24px;
  z-index: 5;
  box-sizing: border-box;
  display: flex;
  gap: 12px;
  width: 280px;
  height: 40px;
}

.custom-date-picker-input-preview {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  width: 195px;
  height: 40px;
  padding: 8px 12px;
  background: #ffffff;
  border: 1px solid #d5d7da;
  box-shadow: 0px 1px 2px rgba(10, 13, 18, 0.05);
  border-radius: 8px;
  font-family: Inter, sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #717680;
}

.custom-date-picker-today {
  box-sizing: border-box;
  width: 73px;
  height: 40px;
  padding: 10px 14px;
  background: #ffffff;
  border: 1px solid #d5d7da;
  box-shadow:
    0px 1px 2px rgba(10, 13, 18, 0.05),
    inset 0px 0px 0px 1px rgba(10, 13, 18, 0.18),
    inset 0px -2px 0px rgba(10, 13, 18, 0.05);
  border-radius: 8px;
  font-family: Inter, sans-serif;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  color: #414651;
  cursor: pointer;
}

.custom-date-picker-dropdown .ant-picker-body {
  padding: 64px 24px 20px !important;
}

.custom-date-picker-dropdown .ant-picker-content {
  width: 280px;
}

.custom-date-picker-dropdown .ant-picker-content th {
  width: 40px;
  height: 40px;
  font-family: Inter, sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: #717680;
}

.custom-date-picker-dropdown .ant-picker-cell {
  width: 40px;
  height: 40px;
  padding: 0;
}

.custom-date-picker-dropdown .ant-picker-cell-inner {
  width: 40px !important;
  height: 40px !important;
  line-height: 40px !important;
  border-radius: 9999px !important;
  font-family: Inter, sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: #414651;
}

.custom-date-picker-dropdown .ant-picker-cell:hover .ant-picker-cell-inner {
  background: #fafafa !important;
}

.custom-date-picker-dropdown .ant-picker-cell-selected .ant-picker-cell-inner {
  background: #9dbc60 !important;
  color: #ffffff !important;
}

.custom-date-picker-dropdown .ant-picker-cell-today .ant-picker-cell-inner::before {
  border: 1px solid #9dbc60 !important;
  border-radius: 9999px !important;
}

.custom-date-picker-dropdown .ant-picker-cell-disabled .ant-picker-cell-inner {
  color: #a4a7ae !important;
  background: transparent !important;
}

.custom-date-picker-dropdown .ant-picker-today-btn {
  display: none !important;
}

.custom-date-picker-dropdown .ant-picker-footer {
  border-top: 1px solid #e9eaeb;
  padding: 16px !important;
}

.custom-date-picker-dropdown .ant-picker-footer-extra {
  padding: 0 !important;
  width: 100%;
}

.custom-date-picker-actions {
  display: flex;
  gap: 12px;
  width: 296px;
  height: 40px;
}

.custom-date-picker-actions button {
  width: 142px;
  height: 40px;
  padding: 10px 14px;
  border-radius: 8px;
  font-family: Inter, sans-serif;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  cursor: pointer;
}

.custom-date-picker-cancel {
  background: #ffffff;
  border: 1px solid #d5d7da;
  color: #414651;
  box-shadow:
    0px 1px 2px rgba(10, 13, 18, 0.05),
    inset 0px 0px 0px 1px rgba(10, 13, 18, 0.18),
    inset 0px -2px 0px rgba(10, 13, 18, 0.05);
}

.custom-date-picker-apply {
  background: #9dbc60;
  border: 1px solid #9dbc60;
  color: #ffffff;
  box-shadow:
    0px 1px 2px rgba(10, 13, 18, 0.05),
    inset 0px 0px 0px 1px rgba(10, 13, 18, 0.18),
    inset 0px -2px 0px rgba(10, 13, 18, 0.05);
}
.custom-date-picker-input-preview {

  outline: none;

}
.custom-date-picker-input-preview {

  box-sizing: border-box;

  display: flex;

  align-items: center;

  width: 195px;

  height: 40px;

  padding: 8px 12px;

  background: #ffffff;

  border: 1px solid #d5d7da;

  box-shadow: 0px 1px 2px rgba(10, 13, 18, 0.05);

  border-radius: 8px;

  font-family: Inter, sans-serif;

  font-weight: 400;

  font-size: 16px;

  line-height: 24px;

  color: #717680;

  outline: none;

}

.custom-date-picker-input-preview:focus {

  border-color: #9dbc60;

}
`;

const DatePickerButton = ({
  value,
  onChange,
  placeholder = 'Datum auswählen',
}) => {
  const [open, setOpen] = React.useState(false);

  const [inputValue, setInputValue] = React.useState(
    value ? value.format('DD.MM.YYYY') : ''
  );

  React.useEffect(() => {
    setInputValue(value ? value.format('DD.MM.YYYY') : '');
  }, [value]);

  React.useEffect(() => {
    if (document.getElementById('custom-date-picker-style')) return;

    const style = document.createElement('style');
    style.id = 'custom-date-picker-style';
    style.innerHTML = popupStyles;
    document.head.appendChild(style);
  }, []);
  const isDateDisabled = (date) => {
    return !date || date.isBefore(moment(), 'day');
  };

  return (
    <DatePickerGlobalStyle>
      <PickerWrap>
        <DateButton type="button" onClick={() => setOpen(true)}>
          <IconWrap>
            <CalendarOutlined />
          </IconWrap>

          <DateText>
            {value ? value.format('DD.MM.YYYY') : placeholder}
          </DateText>
        </DateButton>

        <DatePicker
          className="hidden-ant-picker"
          dropdownClassName="custom-date-picker-dropdown"
          open={open}
          onOpenChange={setOpen}
          value={value}
          locale={locale}
          format={dateFormat || 'DD.MM.YYYY'}
          onChange={onChange}
          allowClear={false}
          showToday={false}
          disabledDate={(d) => !d || d.isBefore(new Date(), 'day')}
          getPopupContainer={(trigger) => trigger.parentElement}
          panelRender={(panelNode) => (
            <div className="custom-date-picker-panel-wrap">
              <div className="custom-date-picker-top-actions">
                <input
                  className="custom-date-picker-input-preview"
                  value={inputValue}
                  placeholder={placeholder}
                  onMouseDown={(e) => {
                    e.stopPropagation();
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                  onChange={(e) => {
                    const text = e.target.value;

                    setInputValue(text);

                    const parsedDate = moment(text, 'DD.MM.YYYY', true);

                    if (parsedDate.isValid() && !isDateDisabled(parsedDate)) {
                      onChange(parsedDate);
                    }
                  }}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      e.preventDefault();

                      const parsedDate = moment(inputValue, 'DD.MM.YYYY', true);

                      if (parsedDate.isValid() && !isDateDisabled(parsedDate)) {
                        onChange(parsedDate);

                        setOpen(false);
                      }
                    }
                  }}
                />

                <button
                  type="button"
                  className="custom-date-picker-today"
                  onMouseDown={(e) => {
                    e.preventDefault();

                    e.stopPropagation();
                  }}
                  onClick={(e) => {
                    e.preventDefault();

                    e.stopPropagation();

                    const today = moment();

                    onChange(today);

                    setOpen(false);
                  }}
                >
                  Heute
                </button>
              </div>

              {panelNode}
            </div>
          )}
          renderExtraFooter={() => (
            <div className="custom-date-picker-actions">
              <button
                type="button"
                className="custom-date-picker-cancel"
                onMouseDown={(e) => e.preventDefault()}
                onClick={() => setOpen(false)}
              >
                Abbrechen
              </button>

              <button
                type="button"
                className="custom-date-picker-apply"
                onMouseDown={(e) => e.preventDefault()}
                onClick={() => setOpen(false)}
              >
                Auswählen
              </button>
            </div>
          )}
        />
      </PickerWrap>
    </DatePickerGlobalStyle>
  );
};

DatePickerButton.propTypes = {
  value: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
};

export default DatePickerButton;
